module.exports = __webpack_public_path__ + "img/dreIcon.8849550e.svg";